const STORAGE_BASE_URL =
  process.env.REACT_APP_API_URL?.replace(/\/$/, '') || 'https://driveshield.net';

export const resolveStorageUrl = (path?: string | null): string => {
  if (!path) {
    return '';
  }

  if (/^https?:\/\//i.test(path)) {
    return path;
  }

  const trimmed = path.replace(/^\/+/, '');
  return `${STORAGE_BASE_URL}/storage/${trimmed}`;
};
